import { CloseOutlined } from "@ant-design/icons";
import { useContext } from "react";
import FeatureCommentsTabComponent from "components/feature-activity-card/feature-comments-tab";
import { ProjectContext } from "context/ProjectProvider";

export function CommentsSidebarHeader({
  title = "Comments",
  caption,
  onClose
}: {
  title?: string;
  caption: string;
  onClose: () => void;
}) {
  return (
    <div
      className="flex items-center justify-between"
      style={{ borderBottom: "1px solid var(--ciq-gray-950-a30)" }}
    >
      <div
        className="p-4 flex items-center overflow-hidden"
        data-testid="custom-report-comments-sidebar-header"
      >
        <span className="shrink-0 sidepanel-header-title">{title}</span>
        <span className="shrink-0 text-xs font-normal ml-2 mr-2">|</span>
        <span className="text-xs font-normal truncate min-w-0" title={caption}>
          {caption}
        </span>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="border-none bg-transparent cursor-pointer p-2"
        data-testid="custom-report-comments-sidebar-close"
      >
        <CloseOutlined />
      </button>
    </div>
  );
}

export function CommentsSidebarContent({
  material,
  onCommentsCountChange
}: {
  material: any;
  onCommentsCountChange?: (count: number) => void;
}) {
  const { isFeatureFlagEnabled } = useContext(ProjectContext);

  return (
    <FeatureCommentsTabComponent
      key={material.id}
      permissions={[]}
      featureKey="feature_instance_id"
      featureId={material.id}
      isAttachementFeatureEnabled={!isFeatureFlagEnabled("DISABLE_ATTACHMENT")}
      auditFeatureType="MATERIALS"
      paddingX="px-6"
      hideCommentInput
      onCommentsCountChange={onCommentsCountChange}
    />
  );
}
